import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RequestService } from './requestService';
import { Page } from '../classes/page';
import { BlogListingModel } from '../../blog-module/models/blog-listing.model';
import {
  BlogCategory,
  BlogPostModel,
  BlogTag,
} from '../../blog-module/models/blog-post.model';
import { LISTING_ITEM_TYPE } from '../../jobs-module/models/listing.model';
import { bounds } from 'leaflet';

@Injectable()
export class BlogService {
  private _apiEndpoint = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private _requestService: RequestService
  ) {}

  public getBlogListings(unit_id: number) {
    return this._requestService.request<Page<BlogListingModel>>(
      'GET',
      `${this._apiEndpoint}blogs/?unit_id=${unit_id}&page_size=1000`
    );
  }

  public getBlogCategories() {
    return this._requestService.request<Page<BlogCategory>>(
      'GET',
      `${this._apiEndpoint}blogs/categories/?page_size=1000`
    );
  }

  public getBlogTags() {
    return this._requestService.request<Page<BlogTag>>(
      'GET',
      `${this._apiEndpoint}blogs/tags/?page_size=1000`
    );
  }

  public createBlogTag(tag: BlogTag) {
    return this._requestService.request<BlogTag>(
      'POST',
      `${this._apiEndpoint}blogs/tags/`,
      null,
      tag
    );
  }

  public createBlogListing(listing: BlogListingModel) {
    return this._requestService.request<BlogListingModel>(
      'POST',
      `${this._apiEndpoint}blogs/`,
      null,
      listing
    );
  }

  public updateBlogListing(listing: BlogListingModel) {
    return this._requestService.request<BlogListingModel>(
      'PUT',
      `${this._apiEndpoint}blogs/${listing.id}/`,
      null,
      listing
    );
  }

  public getBlogListing(id: number) {
    return this._requestService.request<BlogListingModel>(
      'GET',
      `${this._apiEndpoint}blogs/${id}/`
    );
  }

  public checkValidBlogInfo(blog_post: BlogPostModel): boolean {
    if (blog_post) {
      if (blog_post.category) {
        return true;
      }
    }
    return false;
  }

  public checkValidBlogListing(blog_listing: BlogListingModel): boolean {
    if (blog_listing && blog_listing.blog_listing_items) {
      console.log(blog_listing.blog_listing_items.length);
      return blog_listing.blog_listing_items.length > 2;
    }
    return false;
  }

  public createEmptyBlogListing(): BlogListingModel {
    return {
      blog_post: {
        tags: [],
      },
      global_background_rgba: '#FFFFFFFF',
      global_text_style: 'sans',
      blog_listing_items: [
        {
          type: LISTING_ITEM_TYPE.LISTING_ITEM_HEADER,
          position: 0,
          font_rgba: '#000000FF',
          background_rgba: '#FFFFFF00',
        },
        {
          type: LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT,
          position: 1,
          font_rgba: '#000000FF',
          background_rgba: '#FFFFFF00',
        },
        {
          type: LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER,
          position: 2,
          font_rgba: '#000000FF',
          background_rgba: '#FFFFFF00',
        },
      ],
    };
  }
}
